import * as API from "@/services/API";

const API_ENDPOINT = "/adverse-reaction";

export default {
  fetch(data) {
    return API.apiClient.get(API_ENDPOINT, { params: data });
  },

  find(id) {
    return API.apiClient.get(API_ENDPOINT + "/" + id);
  },

  create(model) {
    return API.apiClient.post(API_ENDPOINT, model);
  },

  update(model) {
    return API.apiClient.put(API_ENDPOINT + "/" + model.id, model);
  },

  mediaUpload(id, files) {
    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      formData.append("files[" + i + "]", file);
    }
    return API.apiClient.post(API_ENDPOINT + "/" + id + "/media", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  mediaDownload(id, file) {
    return API.apiClient.get(API_ENDPOINT + "/" + id + "/media/" + file.id, {
      responseType: "blob",
    });
  },

  mediaDelete(id, file) {
    return API.apiClient.delete(API_ENDPOINT + "/" + id + "/media/" + file.id);
  },

  delete(id) {
    return API.apiClient.delete(API_ENDPOINT + "/" + id);
  },

  history(id) {
    return API.apiClient.get(API_ENDPOINT + "/" + id + "/history");
  },

  lastInformation() {
    return API.apiClient.get("/users/information");
  },

  additionStateOptions(step) {
    return API.apiClient.get("/addition/options/" + step);
  },

  deleteLastAddition(id) {
    return API.apiClient.delete(API_ENDPOINT + "/" + id + "/last-addition");
  },

  findLsCounties(medicines, current) {
    return API.apiClient.post("/directories/medicine-medicine/find-counties", {
      medicines: medicines,
      current: current,
    });
  },

  findMnnCounties(client, mnn, current) {
    return API.apiClient.post(
      "/directories/medicine-medicine/mnn/find-counties",
      {
        client: client,
        mnn: mnn,
        current: current,
      }
    );
  },

  deleteCompliance(id) {
    return API.apiClient.delete("/compliance/" + id);
  },

  deleteInformingRegulator(id) {
    return API.apiClient.delete("/informing_regulator/" + id);
  },

  exportExcel(params) {
    // If we passed an array of ids directly (fallback/compatibility), transform it
    const requestParams = Array.isArray(params) ? { id: params } : params;
    return API.apiClient.get("/export" + API_ENDPOINT, {
      params: requestParams,
      responseType: "blob",
    });
  },
};
